import RegularsList from "./RegularsList";

export const RegularsPageConfig = {
	routes: [
		{
			path: "/regulars",
			exact: true,
			component: RegularsList,
		},
	],
};
